import type { Result } from '../types';
import { Level } from '../enums';

class ResultStore {
  value = $state<Result>({
    session: 0,
    startTime: new Date(),
    endTime: new Date(),
    pauseElapsed: 0,
    items: [],
    // responseDetails: [],
    lastStepCompleted: 0,
    wasInterrupted: false,
    comprehensionCorrectFirstTry: 0,
    comprehensionIndependencyIndex: 0,
    readingCorrectFirstTry: 0,
    readingIndependencyIndex: 0,
    spellingCorrectFirstTry: 0,
    spellingIndependencyIndex: 0,
    namingCorrectFirstTry: 0,
    namingIndependencyIndex: 0,
    currentLevel: Level.First
  })
}

export const result = new ResultStore();
